import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { ToasterService } from 'src/app/_services/toaster.service';
import { LoaderService } from 'src/app/_services/loader.service';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.css'],
    standalone: false
})
export class ContactsComponent implements OnInit {

  constructor(
    // private httpClient: HttpClient,
    // tslint:disable-next-line: variable-name
    private _global: Globals,
    private toastr: ToasterService,
    private loader: LoaderService) { }

  Name: string;
  PhoneNumber: string;
  IsFormValid = false;
  // tslint:disable-next-line: member-ordering
  phoneNumberTaken = false;
  timeOut = null;
  ngOnInit() {
    this.Name = '';
  }

  public RegisterPhoneNumberService(): Observable<any> {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    let url = `${this._global.apiUrl}Marketing/Register/PhoneNumber/?Name=` + this.Name;
    url += '&PhoneNumber=' + this.PhoneNumber.replace('+92', '0');
    // // tslint:disable-next-line: max-line-length
    // return this.httpClient.post(url, headers);
    return;
  }

  RegisterPhoneNumber() {
    this.loader.showLoader();
    this.RegisterPhoneNumberService().subscribe(result => {
      if (result) {
        this.toastr.Success('Phone number added successfully.');
      } else {
        this.toastr.Error('Phone number not added!');
      }
      this.Name = '';
      this.PhoneNumber = '';
      this.loader.hideLoader();
    });
  }

  PhoneNumberValidateService(phoneNumber: any) {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    const url = `${this._global.apiUrl}Marketing/Contacts/IsPhoneNumberRegistered?PhoneNumber=` + phoneNumber;
    // return this.httpClient.post(url, headers);
    return;
  }

  isPhoneNumberRegistered(phoneNumber: any) {
    if (phoneNumber !== undefined && phoneNumber != null && phoneNumber.length >= 11) {
      // this.PhoneNumberValidateService(phoneNumber).subscribe(isPhoneNumberRegistered => {
      //   // tslint:disable-next-line: triple-equals
      //   if (isPhoneNumberRegistered) {
      //     this.IsFormValid = false;
      //     this.phoneNumberTaken = true;
      //   } else {
      //     this.IsFormValid = true;
      //     this.phoneNumberTaken = false;
      //     this.toastr.Success('Mobile number added successfully.');
      //   }
      //   this.loader.hideLoader();
      // });
    } else {
      this.loader.hideLoader();
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async pastOnClick(target: any) {
    this.loader.showLoader();
    const text = await navigator.clipboard.readText();
    this.PhoneNumber = text.replace(/\+92/g, '0');
    this.isPhoneNumberRegistered(this.PhoneNumber);
  }
}

